<template>
	<div>
		<div class="sousuo" style="width: 100%">
			<div style="width: 450px" class="yl-flex flex_between">
				<Input placeholder="搜索账户名称" v-model="name" style="width: 300px">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
			</div>
		</div>
		<div class="multiple">
			<div class="child-div">时间区间</div>
			<RadioGroup v-model="timePeriod">
				<Radio label="0"><span>不限</span></Radio>
				<Radio label="1"><span>今日</span></Radio>
				<Radio label="2"><span>昨日</span></Radio>
				<Radio label="3"><span>本周</span></Radio>
				<Radio label="4"><span>上周</span></Radio>
				<Radio label="5"><span>本月</span></Radio>
				<Radio label="6"><span>上月</span></Radio>
				<Radio label="7"><span>自定义</span></Radio>
				<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
					placeholder="选择日期" style="width: 200px"></DatePicker>
			</RadioGroup>
		</div>
		<div class="multiple" style="margin-bottom: 20px;">
			<div class="child-div">搜索条件</div>
			<Select v-model="cidType" style="width:150px;" clearable placeholder="类型">
				<Option v-for="item in cidTypeList" :value="item.id" :key="item.id">{{ item.type }}</Option>
			</Select>
			<Select v-model="city" style="width:150px;" clearable placeholder="城市">
				<Option v-for="item in cityList" :value="item.city" :key="item.city">{{ item.city }}</Option>
			</Select>
			<Select v-model="account" style="width: 100px;margin-left: 10px;width: 150px;" filterable multiple clearable
				placeholder="请选择账户">
				<Option v-for="item in accountList" :value="item.account_id" :key="item.account_id">
					{{ item.account_name}}
				</Option>
			</Select>
			<Select v-model="operationUser" style="width: 100px;margin-left: 10px;width: 150px;" filterable multiple
				clearable placeholder="请选择运营">
				<Option v-for="item in operationList" :value="item.uid" :key="item.uid">
					{{ item.username}}
				</Option>
			</Select>
		</div>
		<Row>
			<Col span="9">
			<div id="myChart1"></div>
			</Col>
			<Col span="15">
			<div id="myChart"></div>
			</Col>
		</Row>

		<div>
			<Input placeholder="总结" v-model="name" style="width: 300px"></Input>
		</div>
		<div style="width: 100% ;margin-top: 20px;">
			<Table stripe border :columns="columns" :data="datas" ref="table">
				<template slot-scope="{ index,row }" slot="type">
					<span style="color:#63B3E6;cursor: pointer;"
						@click.stop="goAdvTypeStaticCity(row.type)">{{row.type}}</span>
				</template>
			</Table>
		</div>
		<Modal v-model="advGroupByCityModal" width="1200" title="">
			<AdvTypeGroupByCityStatic :timePeriod="timePeriod" :timePeriodDate="timePeriodDate">
			</AdvTypeGroupByCityStatic>
		</Modal>
	</div>
</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		getAllMediumCode,
		getAllTypeStatic,
		getAdvTypeGroupByCityStaticList,
		getCidTypeList,
		getAdvCityList,
		getToutiaoSrc,
		getAllAccountList,
		getAllOperationList,
		getOperaterStatic
	} from "../../api/advManage";
	import AdvTypeGroupByCityStatic from "./components/AdvTypeGroupByCityStatic.vue"
	export default {
		name: "all_type_static",
		components: {
			AdvTypeGroupByCityStatic
		},
		props: ['AccountStatic'],
		data() {
			return {
				modal: false,
				name: '',
				timePeriod: '2',
				timePeriodDate: [],
				datas: [],
				advGroupByCityModal: false,
				cidType: [1],
				cidTypeList: [],
				cityList: [],
				accountList: [],
				operationList: [],
				operationUser: [],
				city: [],
				account: [],
				columns: [{
						"title": "姓名",
						"key": "username",
						"align": "center",
					},
					{
						"title": "消耗",
						"key": "cost",
						"align": "center",
						"sortable": true
					},
					{
						"title": "平均成本",
						"key": "average_cost",
						"align": "center",
						"sortable": true
					},
					{
						"title": "广告转化数",
						"key": "account_convert",
						"align": "center",
						"sortable": true
					},
					{
						"title": "系统转化数",
						"key": "srcNum",
						"align": "center",
					},
					{
						"title": "回传数量",
						"key": "backNum",
						"align": "center",
					},
					{
						"title": "1星",
						"key": "one",
						"align": "center",
					},
					{
						"title": "3星",
						"key": "three",
						"align": "center",
					},
					{
						"title": "4星",
						"key": "four",
						"align": "center",
					},
					{
						"title": "2星+",
						"key": "twoPlusAdd",
						"align": "center",
					},
					{
						"title": "2星+优质率",
						"key": "twoPlusRate",
						"align": "center",
					},
					{
						"title": "2星+优质成本",
						"key": "twoPlusCost",
						"align": "center",
					},
					{
						"title": "三星+",
						"key": "threePlus",
						"align": "center",
					},
					{
						"title": "优质率",
						"key": "threePlusRate",
						"align": "center",
					},
					{
						"title": "优质成本",
						"key": "threePlusCost",
						"align": "center",
					},
				],
				optionData: {
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '5%',
						left: 'center'
					},
					series: [{
						name: 'Access From',
				　　type : 'pie',
				　　radius : '65%',
				　　center : [ '50%', '40%' ],
						avoidLabelOverlap: false,
						　　label : {
						　　　　normal : {
						　　　　　　formatter: '{b}:{c}: ({d}%)',
						position: "inner",
						　　　　　　textStyle : {
						　　　　　　　　fontWeight : 'normal',
						　　　　　　　　fontSize : 15
						　　　　　　}
						　　　　}
						　　},
						emphasis: {
							label: {
								show: true,
								fontSize: '40',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: []
					}]
				},
				optionMy: {
					legend: {
						orient: 'horizontal', // 布局方式，默认为水平布局，可选为：
						// 'horizontal' ¦ 'vertical'
						x: 'center', // 水平安放位置，默认为全图居中，可选为：
						// 'center' ¦ 'left' ¦ 'right'
						// ¦ {number}（x坐标，单位px）
						y: 'top', // 垂直安放位置，默认为全图顶端，可选为：
						// 'top' ¦ 'bottom' ¦ 'center'
						// ¦ {number}（y坐标，单位px）
						backgroundColor: 'rgba(0,0,0,0)',
						borderColor: '#ccc', // 图例边框颜色
						borderWidth: 0, // 图例边框线宽，单位px，默认为0（无边框）
						padding: 5, // 图例内边距，单位px，默认各方向内边距为5，
						// 接受数组分别设定上右下左边距，同css
						itemGap: 10, // 各个item之间的间隔，单位px，默认为10，
						// 横向布局时为水平间隔，纵向布局时为纵向间隔
						itemWidth: 20, // 图例图形宽度
						itemHeight: 14, // 图例图形高度
						textStyle: {
							color: '#333' // 图例文字颜色
						},
					},
					title: {
						text: ''
					},
					tooltip: {},
					xAxis: {
						data: []
					},
					yAxis: [{
							type: 'value',
							name: '成本',
							position: "left",
							offset: 0,
							min: 0,
							splitNumber: 6, //设置坐标轴的分割段数
						},
						{
							type: 'value',
							name: '数量',
							position: "left",
							offset: 70,
							min: 0,
							interval: 100,
							splitNumber: 6, //设置坐标轴的分割段数
						},
						{
							type: 'value',
							name: '优质率',
							min: 0,
							max: 1,
							interval: 25,
							splitNumber: 6, //设置坐标轴的分割段数
						}
					],
					series: [{
						name: '转化',
						type: 'bar',
						yAxisIndex: 1,
						color: 'rgb(135 206 250)',
						data: [],
						itemStyle: {
							normal: {
								label: {
									show: true, //是否展示
									textStyle: {
										fontWeight: 'bolder',
										color: "#060909",
										fontSize: '16',
										fontFamily: '微软雅黑',
									}
								}
							}
						}
					}, {
						name: '平均成本',
						type: 'bar',
						data: [],
						yAxisIndex: 0,
						itemStyle: {
							normal: {
								label: {
									show: true, //是否展示
									textStyle: {
										fontWeight: 'bolder',
										fontSize: '14',
										fontFamily: '微软雅黑',
									}
								}
							}
						}
					}, {
						name: '优质成本',
						type: 'bar',
						data: [],
						itemStyle: {
							normal: {
								label: {
									show: true, //是否展示
									textStyle: {
										fontWeight: 'bolder',
										fontSize: '14',
										fontFamily: '微软雅黑',
									}
								}
							}
						}
					}, {
						name: '优质率',
						type: 'line',
						yAxisIndex: 2,
						data: [],
						itemStyle: {
							normal: {
								label: {
									show: true, //是否展示
									textStyle: {
										fontWeight: 'bolder',

										fontSize: '16',
										fontFamily: '微软雅黑',
									}
								}
							}
						}
					}]
				}
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();
			this.getdata();
			this.getList();
		},
		methods: {

			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.timePeriod = '2';
				this.timePeriodDate = [];
				this.cidType = [1];
				this.city = [];
				this.account = [];
				this.operationUser = [];
				this.getList();
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getCidTypeList(that, data);
				that.cidTypeList = res.data.list
				res = await getAdvCityList(that, data);
				that.cityList = res.data.list
				res = await getToutiaoSrc(that, data);
				that.srcList = res.data.list;
				res = await getAllAccountList(that, data);
				that.accountList = res.data.list;
				res = await getAllOperationList(that, data);
				that.operationList = res.data.list;
			},
			goAdvTypeStaticCity() {
				this.advGroupByCityModal = true;
			},
			getdata() {
				let myChart1 = this.$echarts.init(document.getElementById("myChart1"));
				myChart1.clear();
				console.log(this.optionData)
				myChart1.setOption(this.optionMy);
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				data.cidType = this.cidType;
				data.city = this.city;
				data.account = this.account;
				data.operationUser = this.operationUser;
				let res = await getOperaterStatic(that, data);
				let myChart = this.$echarts.init(document.getElementById("myChart"));
				that.datas = res.data.list;
				//图表准备
				var obj = that.datas;
				var sxAxis = [];
				var numSeries = [];
				var averageCostSeries = [];
				var threePlusCostSeries = [];
				var threePlusRateSeries = [];
				var pieData = [];

				//坐标和数据都push到数组中
				for (var i = 1; i < obj.length; i++) {
					sxAxis.push(
						obj[i].username
					);
					numSeries.push(
						obj[i].srcNum
					);
					averageCostSeries.push(
						obj[i].average_cost
					);
					threePlusCostSeries.push(
						obj[i].threePlusCost
					);
					threePlusRateSeries.push(
						obj[i].threePlusRate
					);
					var obj1 = new Object();
					obj1.name = obj[i].username; //回答调查问卷的答案
					obj1.value = obj[i].srcNum; //回答调查问卷的人数
					pieData[i] = obj1;
					console.log(pieData)
				}
				that.optionMy.xAxis.data = sxAxis;
				that.optionMy.series[0].data = numSeries;
				that.optionMy.series[1].data = averageCostSeries;
				that.optionMy.series[2].data = threePlusCostSeries;
				that.optionMy.series[3].data = threePlusRateSeries;
				that.optionData.series[0].data = pieData;
				myChart.clear();
				myChart.setOption(this.optionMy);
				let myChart1 = this.$echarts.init(document.getElementById("myChart1"));
				myChart1.clear();
				myChart1.setOption(this.optionData);

			},

			search() {
				this.getList();
			}
		},


	}
</script>
<style scoped lang="less">
	#myChart1 {
		width: 100%;
		height: 700px;
		background-color: #FFFFFF;
		padding-top: 30px;
	}

	#myChart {
		width: 100%;
		height: 700px;
		background-color: #FFFFFF;
		padding-top: 30px;
	}

	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>
